import * as i0 from '@angular/core';
import { PLATFORM_ID, Injectable, Inject, NgModule } from '@angular/core';
import * as i2 from '@adeo/ngx-kozikaza-api';
import { BaseService, KOZIKAZA_API_OPTIONS, createSubResourceObservable, ProfessionalService, ProfessionalParticularService, createSubResourceObservables } from '@adeo/ngx-kozikaza-api';
import * as i1 from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ProfessionalCoachingRequestService, ProCoachingRequestApiModule } from '@adeo/ngx-kozikaza-api/pro/coaching-request';

var ProfessionalFavoriteSubResource;
(function (ProfessionalFavoriteSubResource) {
    ProfessionalFavoriteSubResource.Professional = 'professional';
    ProfessionalFavoriteSubResource.Author = 'author';
})(ProfessionalFavoriteSubResource || (ProfessionalFavoriteSubResource = {}));

var TenderAnswerSubResource;
(function (TenderAnswerSubResource) {
    TenderAnswerSubResource.Coach = 'coach';
    TenderAnswerSubResource.Tender = 'tender';
    TenderAnswerSubResource.CoachingRequests = 'coachingRequests';
})(TenderAnswerSubResource || (TenderAnswerSubResource = {}));

var TenderSubResource;
(function (TenderSubResource) {
    TenderSubResource.Customer = 'customer';
    TenderSubResource.TenderAnswers = 'tenderAnswers';
})(TenderSubResource || (TenderSubResource = {}));

var ProfessionalTenderState;
(function (ProfessionalTenderState) {
    ProfessionalTenderState["OPENED"] = "opened";
    ProfessionalTenderState["CLOSED"] = "closed";
    ProfessionalTenderState["CREATED"] = "created";
})(ProfessionalTenderState || (ProfessionalTenderState = {}));

class ProfessionalInstagramService extends BaseService {
    platformId;
    injector;
    static endpoint = '/professionals/instagram';
    static endpointMediasSuffix = '/medias';
    static endpointLongLivedTokenSuffix = '/long-lived-token';
    getWebServiceName() {
        return 'ProfessionalInstagramService';
    }
    constructor(options, httpClient, platformId, cache, logger, injector) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
        this.injector = injector;
    }
    postLongLivedToken(data, options) {
        return this.postNoHydraMember(ProfessionalInstagramService.endpoint + ProfessionalInstagramService.endpointLongLivedTokenSuffix, data, options);
    }
    getProfessionalInstagramMedias(options) {
        return this.getNoHydraMember(ProfessionalInstagramService.endpoint + ProfessionalInstagramService.endpointMediasSuffix, options);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalInstagramService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalInstagramService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalInstagramService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }, { type: i0.Injector }]; } });

class ProfessionalLanguageLegacyService extends BaseService {
    platformId;
    static endpoint = '/professionals/languages';
    static endpointPrefix = '/professionals';
    getWebServiceName() {
        return 'ProfessionalLanguageLegacyWebService';
    }
    constructor(options, httpClient, platformId, cache, logger) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
    }
    getLanguages(translationLanguage, options) {
        return this.getNoHydraMember(`${ProfessionalLanguageLegacyService.endpoint}${translationLanguage ? '/' + translationLanguage : ''}`, options);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalLanguageLegacyService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalLanguageLegacyService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalLanguageLegacyService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }]; } });

class ProfessionalFavoriteService extends BaseService {
    platformId;
    injector;
    static endpoint = '/professionals/favorites';
    static endpointPrefix = '/professionals';
    static endpointParticularsSuffix = '/particulars';
    getWebServiceName() {
        return 'ProfessionalFavoriteWebService';
    }
    constructor(options, httpClient, platformId, cache, logger, injector) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
        this.injector = injector;
    }
    postProfessionalFavorite(professionalFavorite, options) {
        return this.post(ProfessionalFavoriteService.endpoint, professionalFavorite, options);
    }
    getProfessionalFavorites(subResources, options) {
        return this.getResources(ProfessionalFavoriteService.endpoint, subResources, options);
    }
    /*  getProfessionalFavoritesNavigator(
        subResources?: ProfessionalFavoriteSubResources,
        options?: WebServiceOptions,
      ): Observable<HydraCollectionNavigator<ProfessionalFavorite>> {
        return this.getProfessionalFavorites(subResources, options)
          .pipe(
            map(collection => new HydraCollectionNavigator(this, collection, subResources, options)),
          )
          ;
      }*/
    getProfessionalJob(professionalFavorite, subResources, options) {
        return this.getResource(ProfessionalFavoriteService.endpointPrefix +
            (typeof professionalFavorite === 'string' ? professionalFavorite : professionalFavorite['@id']), subResources, options);
    }
    putProfessionalFavorite(professionalFavorite, options) {
        return this.updateResource(ProfessionalFavoriteService.endpointPrefix +
            (typeof professionalFavorite === 'string' ? `${ProfessionalFavoriteService.endpointPrefix}` + professionalFavorite :
                professionalFavorite['@id']), professionalFavorite, options);
    }
    deleteProfessionalFavorite(professionalFavorite, options) {
        return this.delete(ProfessionalFavoriteService.endpointPrefix +
            (typeof professionalFavorite === 'string' ? `${ProfessionalFavoriteService.endpointPrefix}` + professionalFavorite :
                professionalFavorite['@id']), options);
    }
    getSubResourceObservable(professionalFavorite, subResourceRequest, options) {
        switch (subResourceRequest[0]) {
            case ProfessionalFavoriteSubResource.Professional:
                if (professionalFavorite.professional) {
                    return createSubResourceObservable(this.injector.get(ProfessionalService).getProfessional(professionalFavorite.professional, subResourceRequest[1], options), options)
                        .pipe(map(professional => {
                        professionalFavorite.professional = professional;
                        return professionalFavorite;
                    }));
                }
                return undefined;
            case ProfessionalFavoriteSubResource.Author:
                if (professionalFavorite.author) {
                    const ownerId = typeof professionalFavorite.author === 'string'
                        ? professionalFavorite.author : professionalFavorite.author['@id'];
                    const ownerIsParticular = ownerId.includes(ProfessionalFavoriteService.endpointParticularsSuffix);
                    // check if particular or professional (by checking if professionalActivatedCoupon.owner
                    // contains /professionals or /particulars)
                    return createSubResourceObservable(ownerIsParticular
                        ? this.injector.get(ProfessionalService).getProfessional(ownerId, subResourceRequest[1], options)
                        : this.injector.get(ProfessionalParticularService).getProfessionalParticular(ownerId, subResourceRequest[1], options), options)
                        .pipe(map(author => {
                        professionalFavorite.author = author;
                        return professionalFavorite;
                    }));
                }
                return undefined;
            default:
                return undefined;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalFavoriteService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalFavoriteService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalFavoriteService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }, { type: i0.Injector }]; } });

class ProfessionalTenderAnswerService extends BaseService {
    platformId;
    injector;
    static endpoint = '/professionals/tenders_answers';
    static endpointPrefix = '/professionals';
    getWebServiceName() {
        return 'TenderAnswerWebService';
    }
    constructor(options, httpClient, platformId, cache, logger, injector) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
        this.injector = injector;
    }
    getTenderAnswers(subResources, options) {
        return this.getResources(ProfessionalTenderAnswerService.endpoint, subResources, options);
    }
    getTenderAnswer(tenderAnswer, subResources, options) {
        return this.getResource(`${ProfessionalTenderAnswerService.endpointPrefix}${typeof tenderAnswer === 'string' ? tenderAnswer : tenderAnswer['@id']}`, subResources, options);
    }
    postTenderAnswerNotify(tenderAnswer, options) {
        return this.post(`${ProfessionalTenderAnswerService.endpointPrefix}${typeof tenderAnswer === 'string' ? tenderAnswer : tenderAnswer['@id']}/notify`, options);
    }
    getSubResourceObservable(professionalTenderAnswer, subResourceRequest, options) {
        switch (subResourceRequest[0]) {
            case TenderAnswerSubResource.Tender:
                if (professionalTenderAnswer.tender) {
                    const tenderId = typeof professionalTenderAnswer.tender === 'string'
                        ? professionalTenderAnswer.tender : professionalTenderAnswer.tender['@id'];
                    return createSubResourceObservable(this.injector.get(ProfessionalTenderService).getTender(tenderId, subResourceRequest[1], options), options).pipe(map(tender => {
                        professionalTenderAnswer.tender = tender;
                        return professionalTenderAnswer;
                    }));
                }
                return undefined;
            case TenderAnswerSubResource.Coach:
                if (professionalTenderAnswer.coach) {
                    return createSubResourceObservable(this.injector.get(ProfessionalService).getProfessional(professionalTenderAnswer.coach, subResourceRequest[1], options), options).pipe(map(coach => {
                        professionalTenderAnswer.coach = coach;
                        return professionalTenderAnswer;
                    }));
                }
                return undefined;
            case TenderAnswerSubResource.CoachingRequests:
                if (professionalTenderAnswer.coachingRequests && professionalTenderAnswer.coachingRequests.length) {
                    const coachingsObservable = [];
                    professionalTenderAnswer.coachingRequests.map((coachingRequest) => {
                        coachingsObservable.push(this.injector.get(ProfessionalCoachingRequestService).getProfessionalCoachingRequest('/coaching_requests/' + coachingRequest, subResourceRequest[1], options));
                    });
                    return createSubResourceObservables(coachingsObservable, options, professionalTenderAnswer.coachingRequests)
                        .pipe(map(coachingRequests => {
                        professionalTenderAnswer.coachingRequests = coachingRequests;
                        return professionalTenderAnswer;
                    }));
                }
                return undefined;
            default:
                return undefined;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalTenderAnswerService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalTenderAnswerService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalTenderAnswerService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }, { type: i0.Injector }]; } });

class ProfessionalTenderService extends BaseService {
    platformId;
    injector;
    static endpoint = '/professionals/tenders';
    static endpointPrefix = '/professionals';
    static endpointParticularsSuffix = '/particulars';
    getWebServiceName() {
        return 'TenderWebService';
    }
    constructor(options, httpClient, platformId, cache, logger, injector) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
        this.injector = injector;
    }
    postTenders(tender, options) {
        return this.post(ProfessionalTenderService.endpoint, tender, options);
    }
    getTenders(subResources, options) {
        return this.getResources(ProfessionalTenderService.endpoint, subResources, options);
    }
    /*    getTendersNavigator(
            subResources?: TenderSubResources,
            options?: WebServiceOptions,
        ): Observable<HydraCollectionNavigator<ProfessionalTender>> {
            return this.getTenders(subResources, options)
                .pipe(
                    map(collection => new HydraCollectionNavigator(this, collection, subResources, options)),
                )
                ;
        }*/
    getTender(tender, subResources, options) {
        return this.getResource(`${ProfessionalTenderService.endpointPrefix}${typeof tender === 'string' ? tender : tender['@id']}`, subResources, options);
    }
    putTender(tender, options) {
        return this.updateResource(`${ProfessionalTenderService.endpointPrefix}${typeof tender === 'string' ? tender : tender['@id']}`, tender, options);
    }
    deleteTender(tender, options) {
        return this.delete(`${ProfessionalTenderService.endpointPrefix}${typeof tender === 'string' ? tender : tender['@id']}`, options);
    }
    addCoaches(tender, coaches, options) {
        return this.post(`${ProfessionalTenderService.endpointPrefix}${typeof tender === 'string' ? tender : tender['@id']}/add_coaches`, { coaches }, options);
    }
    removeCoaches(tender, coaches, options) {
        return this.post(`${ProfessionalTenderService.endpointPrefix}${typeof tender === 'string' ? tender : tender['@id']}/remove_coaches`, { coaches }, options);
    }
    closeTender(tender, options) {
        return this.post(`${ProfessionalTenderService.endpointPrefix}${typeof tender === 'string' ? tender : tender['@id']}/close`, {}, options);
    }
    getSubResourceObservable(professionalTender, subResourceRequest, options) {
        switch (subResourceRequest[0]) {
            case TenderSubResource.Customer:
                if (professionalTender.customer) {
                    const ownerId = typeof professionalTender.customer === 'string'
                        ? professionalTender.customer : professionalTender.customer['@id'];
                    const ownerIsParticular = ownerId.includes(ProfessionalTenderService.endpointParticularsSuffix);
                    // check if particular or professional (by checking if professionalCoachingRequest.owner
                    // contains /professionals or /particulars)
                    return createSubResourceObservable(ownerIsParticular
                        ? this.injector.get(ProfessionalService).getProfessional(ownerId, subResourceRequest[1], options)
                        : this.injector.get(ProfessionalParticularService).getProfessionalParticular(ownerId, subResourceRequest[1], options), options)
                        .pipe(map(owner => {
                        professionalTender.customer = owner;
                        return professionalTender;
                    }));
                }
                return undefined;
            case TenderSubResource.TenderAnswers:
                if (professionalTender.tenderAnswers) {
                    if (professionalTender.tenderAnswers && professionalTender.tenderAnswers.length > 0) {
                        const tenderAnswersObservable = [];
                        professionalTender.tenderAnswers.map(tenderAnswer => {
                            tenderAnswersObservable.push(this.injector.get(ProfessionalTenderAnswerService).getTenderAnswer(tenderAnswer, subResourceRequest[1], options));
                        });
                        return createSubResourceObservables(tenderAnswersObservable, options, professionalTender.tenderAnswers)
                            .pipe(map(tenderAnswers => {
                            professionalTender.tenderAnswers = tenderAnswers;
                            return professionalTender;
                        }));
                    }
                }
            default:
                return undefined;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalTenderService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalTenderService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProfessionalTenderService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }, { type: i0.Injector }]; } });

const WEB_SERVICES = [
    ProfessionalFavoriteService,
    ProfessionalInstagramService,
    ProfessionalLanguageLegacyService,
    ProfessionalTenderService,
    ProfessionalTenderAnswerService,
];
class ProMiscApiModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProMiscApiModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.8", ngImport: i0, type: ProMiscApiModule, imports: [ProCoachingRequestApiModule] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProMiscApiModule, providers: [
            ...WEB_SERVICES,
        ], imports: [ProCoachingRequestApiModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ProMiscApiModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        ProCoachingRequestApiModule
                    ],
                    providers: [
                        ...WEB_SERVICES,
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ProMiscApiModule, ProfessionalFavoriteService, ProfessionalFavoriteSubResource, ProfessionalInstagramService, ProfessionalLanguageLegacyService, ProfessionalTenderAnswerService, ProfessionalTenderService, ProfessionalTenderState, TenderAnswerSubResource, TenderSubResource };
